import { Box, styled } from '@mui/material';

const navbarHeight = 50;

export const HomeContainer = styled(Box)(() => ({
  width: '100%',
  minHeight: `calc(100vh - ${navbarHeight}px)`,

  '@media screen and (max-width: 640px)': {
    minHeight: `100vh`,
  },
  display: 'flex',
}));

export const ContactsContainer = styled(Box)(() => ({
  height: '100%',
  marginLeft: '12px',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  rowGap: '16px',

  top: 0,
  left: 0,

  position: 'absolute',

  '@media screen and (max-width: 640px)': {
    width: '100%',
    height: 'unset',
    marginLeft: 'unset',
    marginBottom: '12px',

    flexDirection: 'row',
    columnGap: '16px',

    top: 'unset',
    bottom: 0,
  },
}));

export const ContentContainer = styled(Box)(() => ({
  margin: 'auto',

  display: 'flex',
  flexDirection: 'row',
  gap: '24px',

  '@media screen and (max-width: 1280px)': {
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const InfoContainer = styled(Box)(() => ({
  margin: 'auto',

  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}));

export const NameContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const DescriptionContainer = styled(Box)(() => ({
  display: 'flex',
  maxWidth: '600px',

  '@media screen and (min-width: 1920px)': {
    maxWidth: '800px',
  },

  '@media screen and (max-width: 1280px)': {
    maxWidth: '440px',
  },

  '@media screen and (max-width: 640px)': {
    maxWidth: '350px',
  },
}));
